import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title>Wine Pairing Events at Villaggio Grille</title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>April Wine Pairing</h1>
                  <h4 className="one">
                    April 30th &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $60 per guest
                    <br className="fullBr" />
                    Hosted by Alabama Crown
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="sectionWrap insideNrw food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <h4>Beet &amp; Herb Terrine</h4>
                <h5>Red &amp; Golden Beets, Garlic, &amp; Goat Cheese</h5>
                <p>Paired with</p>
                <h4>Loimer · Kamptal Grüner Veltliner · Lois '22</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Two</h3>
                <h4>Philly Cheesesteak Eggrolls</h4>
                <h5>Filet Mignon Chopped with Bell Pepper, Onion, &amp; Mushroom, with Queso Blanco Dipping Sauce</h5>
                <p>Paired with</p>
                <h4>Tinto Negro · Malbec Reserve · Valle de Uco '23</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Three</h3>
                <h4>Bacon, Spinach, &amp; Cheese Stuffed Chicken Breast</h4>
                <h5>
                  Applewood Bacon Pieces, Spinach, Garlic, &amp; Herb Cream Cheese, Stuffed in Rosemary Chicken Breast. Served with 
                  Roasted Brussel Sprouts, Caramelized Onions, &amp; Duchess Mashed Potatoes
                </h5>
                <p>Paired with</p>
                <h4>Scott Family Cellars · Pinot Noir · California '23</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">                
                <h3>Course Four</h3>
                <h4>Lemon Ricotta Cake</h4>
                <h5>Lemon Zest Cake with Ricotta Cheese, Raspberries, &amp; Raspberry Puree </h5>
                <p>Paired with</p>
                <h4>Schloss Vollrads · Rheingau Riesling · Qualitätswein</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
